import React, { useState } from 'react'

import './Login.css'
import { NavLink, useNavigate } from 'react-router-dom';
// import { useSelector } from 'react-redux';
import { userdetails } from '../../../store/actions/actionType.js';
import store from "../../../store/store.js"
import axios from 'axios';
import { notification, Form, Input, Button, Typography } from 'antd';



const { Title, Text } = Typography;

const backend_url = process.env.REACT_APP_BACKEND_URL

function Login(props) {



  const history = useNavigate()

  
  const [form] = Form.useForm();
  




  const handleSubmit = async () => {
    try {
      const username = form.getFieldValue('username') || '';  // Get username from form
      const formEmail = form.getFieldValue('email') || '';    // Get email from form
      const password = form.getFieldValue('password') || '';  // Get password from form
  
      console.log('Form Username:', username);
      console.log('Form Email:', formEmail);
      console.log('Password:', password);
      console.log('Inside login');
  
      // Check if either email or username is provided
      if (!formEmail && !username) {
        throw new Error("Please provide either an email or username.");
      }
  
      props.setLoad(true); // Start loading spinner
  
      // Make the API request to log in
      const response = await fetch(`${backend_url}/api/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: formEmail, username, password }),
      });
  
      const res = await response.json();
      console.log('Response:', res);
  
      if (response.ok) {
        // If login is successful and token is present
        if (res.result && res.result.token) {
          console.log('Login Successful');
  
          // Store token and provided username/email in localStorage
          localStorage.setItem('userdatatoken', res.result.token);
          localStorage.setItem('username', username || formEmail);
  
          // Success notification
          notification.success({
            message: 'Login Successful',
            description: 'You have successfully logged in.',
          });
  
          // Fetch user details using Axios
          const userResponse = await axios.get(`${backend_url}/api/user-details`, {
            // params: { email: formEmail }, // Use email to fetch user details
            params: { 
              email: formEmail || undefined, // Use email if available
              username: username || formEmail // Use username or email to fetch details
            }, 
          });
  
          const { fname, email: responseEmail, mobile, ticketNumbers, username: fetchedUsername } = userResponse.data.user;
  
          // Dispatch user details to Redux store, including username if fetched
          store.dispatch(userdetails({
            username: username || fetchedUsername, // Use the fetched username if the form username is not available
            email: responseEmail,
            fname,
            mobile,
            ticketNumbers,
          }));
  
          // Store the fetched username in localStorage if it wasn't provided initially
          if (!username && fetchedUsername) {
            localStorage.setItem('username', fetchedUsername);
          }
  
          // Redirect to the home page after successful login
          history('/');
  
          // Reset form fields after successful login
          form.resetFields();
        } else {
          // If login failed but the API returned a 200 status
          notification.error({
            message: 'Login Failed',
            description: res.message || 'Invalid username or password.',
          });
  
          form.resetFields();
        }
      } else {
        // If the response status is not ok (e.g., 4xx or 5xx)
        console.log('Backend error:', res.error || res.message);
  
        notification.error({
          message: 'Login Error',
          description: res.error || res.message || 'An error occurred during login.',
        });
  
        form.resetFields();
      }
    } catch (err) {
      console.error('Caught error:', err);
  
      // Handle network or other errors
      notification.error({
        message: 'Login Error',
        description: err.message || 'There was an error processing your request. Please try again.',
      });
  
      form.resetFields();
    } finally {
      props.setLoad(false); // Stop the spinner once the process is done
    }
  };
  


















  return (
    <>
      <div className="login">


        <div className="login-form-container">
          

          <Form
            form={form}
            onFinish={handleSubmit}
            layout="vertical"
            className="login-form"
          >
            <h2 className='font-black text-lg text-center '>Login</h2>
           <hr/>

            <Form.Item
              label="Username"
              name="username"
              rules={[
                {
                  required: false,
                  message: 'Please input your username!',
                },
              ]}
            >
              <Input placeholder="Enter your username" />
            </Form.Item>

            <span style={{ textAlign: 'center', color: 'green' }}>OR</span>

            <Form.Item
              label="Email"
              name="email"
              rules={[
                {
                  type: 'email',
                  message: 'The input is not valid E-mail!',
                },
                {
                  required: false,
                  message: 'Please input your email!',
                },
              ]}
            >
              <Input placeholder="Enter your email" />
            </Form.Item>

            <Form.Item
              label="Password"
              name="password"
              rules={[
                {
                  required: true,
                  message: 'Please input your password!',
                },
              ]}
            >
              <Input.Password placeholder="Enter your password" />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" block>
                Login
              </Button>
            </Form.Item>

            <Text className="text-black transition duration-300">
              Don't have an account?{' '}
              <span onClick={props.onFlip} className="cursor-pointer font-black">
                Sign up
              </span>
            </Text>
          </Form>
        </div>




      </div>






    </>
  )
}

export default Login